<template>
  <div>
    <block-driver @refetch-inactivations="$emit('refetch-inactivation-list')" />
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="inactivationListLoading"
    >
      <sticky-driver-data
        viewd-in="inactivation-list"
        @refetch-inactivation-list="$emit('refetch-inactivation-list')"
      />
      <b-card>
        <b-button
          v-if="$can('write', 'driver-inactivations') && !hideBlockBtn"
          v-b-modal.block-driver
          variant="primary"
          class="mb-1"
        >
          Block
        </b-button>
        <b-tabs>
          <b-tab active>
            <template #title>
              <feather-icon
                icon="XIcon"
                size="16"
                class="mr-0 mr-sm-50"
              />
              <span class="d-none d-sm-inline">Unresolved</span>
            </template>
            <inactivations-un-resolved-list
              :table-columns="tableColumns"
              @refetch-inactivation-list="refetchInactivationTable"
              @refetch-driver-details="$emit('refetch-driver-details')"
            />
          </b-tab>
          <b-tab>
            <template #title>
              <feather-icon
                icon="CheckIcon"
                size="16"
                class="mr-0 mr-sm-50"
              />
              <span class="d-none d-sm-inline">Resolved</span>
            </template>
            <inactivations-resolved-list
              :table-columns="tableColumns"
            />
          </b-tab>
        </b-tabs>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTabs, BTab, BButton, VBModal,
} from 'bootstrap-vue'
import {
  computed,
} from '@vue/composition-api'
import StickyDriverData from '../../StickyDriverData.vue'
import InactivationsResolvedList from './resolved-list/InactivationsResolvedList.vue'
import InactivationsUnResolvedList from './unresolved-list/InactivationsUnResolvedList.vue'
import BlockDriver from './BlockDriver.vue'
import store from '@/store'
import useResolveCondition from './useResolveCondition'
import formatDate from '@/utils/date-format'

export default {
  components: {
    BButton,
    BCard,
    BOverlay,
    BTabs,
    BTab,
    BlockDriver,
    StickyDriverData,
    InactivationsResolvedList,
    InactivationsUnResolvedList,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    inactivationListLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(_, ctx) {
    const tableColumns = [
      { key: 'created_at', label: 'Date & Time' },
      { key: 'inactivation_reason', label: 'Reason' },
      { key: 'created_by', label: 'Added By' },
      { key: 'note' },
      { key: 'auto_resolve_on', label: 'Resolve On', formatter: val => formatDate(val) },
    ]
    const unresolvedList = computed(() => store.getters['driverView/getUnResolvedInactivations'])
    const hideBlockBtn = computed(() => !!unresolvedList.value?.find(inactivation => useResolveCondition(inactivation)))
    const refetchInactivationTable = () => {
      ctx.emit('refetch-inactivation-list')
    }

    return {
      tableColumns,
      hideBlockBtn,
      refetchInactivationTable,
    }
  },
}
</script>

<style>

</style>
